import apiInputService from "services/apiInputService";
import { useQuery } from "@tanstack/react-query";

const fetch = async (pickList: string): Promise<IPickList> => {
  const { data } = await apiInputService.get(`/frontend/picklist/${pickList}`);

  return data as IPickList;
};

export const useGetPickList = (pickList: string, options?: any) =>
  useQuery([`pick-list-${pickList}`], () => fetch(pickList), {
    ...options,
    staleTime: 0,
  });
